import { deleteParamFromQueryByName } from '@keaze/web/utils/deleteParamFromQueryByName';
import { OnQueryDialogClick } from './queryDialog.types';

export const onQueryDialogClick: OnQueryDialogClick = ({
  router,
  name,
  value = '',
}) => {
  const isQueryParamName = !!(router.query[name] as string);

  if (isQueryParamName) {
    return deleteParamFromQueryByName({
      name,
      router,
      withShallow: true,
    });
  }

  const query = { ...router.query, [name]: value };

  return router.push({ query }, undefined, {
    shallow: true,
  });
};
